import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



    const cardData = {

keyword: "Best Cab Service in Pune",

headingDescription:
    "Rising Cab Service offers the Best Cab Service in Pune with safe, reliable, and comfortable travel solutions for local rides, airport transfers, railway station pickups, corporate travel, and outstation trips. We provide a wide range of vehicles including Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury cars with professional and verified drivers. With 24/7 availability, doorstep pickup across Pune, transparent pricing, and easy booking options, we ensure a smooth, hassle-free, and premium travel experience for every passenger.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular weekend getaways from Pune, known for misty hills, lush valleys, waterfalls, and scenic viewpoints like Tiger Point and Bhushi Dam. These twin hill stations are perfect for monsoon drives, family trips, and short relaxing holidays."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba. Devotees travel from Pune to visit Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi, making it one of the most trusted spiritual cab routes."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a major religious and cultural destination known for Trimbakeshwar Jyotirlinga, Panchavati temples, and the Godavari river ghats. It also offers vineyard experiences and scenic drives, making it a perfect mix of spirituality and leisure travel."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, waterfalls, and cool climate. Attractions like Arthur’s Seat, Venna Lake, and Elephant’s Head Point make it a top choice for family and couple trips from Pune."
    },
    {
        title: "Mumbai City",
        description:
            "Mumbai is a major metro destination from Pune known for Gateway of India, Marine Drive, Juhu Beach, and corporate hubs. It is widely used for business travel, airport transfers, and weekend leisure trips."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular destination for pilgrims and trekkers seeking both spiritual darshan and nature experiences."
    },
    {
        title: "Lavasa Hill City",
        description:
            "Lavasa is a planned hill city near Pune known for lakeside promenades, boating, colorful architecture, and peaceful surroundings. It is a short and relaxing getaway ideal for weekend trips."
    },
    {
        title: "Goa Beaches",
        description:
            "Goa is a long-distance holiday destination from Pune famous for beaches, nightlife, water sports, and scenic coastal drives. It is one of the most popular routes for group tours and vacation cab bookings."
    },
    {
        title: "Aurangabad Heritage Circuit",
        description:
            "Aurangabad is known for UNESCO World Heritage Sites like Ajanta Caves and Ellora Caves along with Bibi Ka Maqbara. It is a top long-distance travel destination from Pune for history and culture exploration."
    },
    {
        title: "Tamhini Ghat & Mulshi",
        description:
            "Tamhini Ghat and Mulshi are scenic monsoon destinations near Pune known for waterfalls, green valleys, and dam views. They are popular short trips for nature lovers and photography enthusiasts."
    }
],



services: [
{
name: "Best Cab Service in Pune",
description: "Rising Cab Service offers the Best Cab Service in Pune with highly reliable, safe, and comfortable transportation for all types of travel including local rides, airport transfers, and long-distance outstation journeys. We provide well-maintained AC vehicles, experienced and professional drivers, 24x7 availability, and doorstep pickup and drop service. Our focus is on punctuality, passenger safety, and smooth travel experience for families, corporate clients, and tourists across Pune and nearby regions."
},
{
name: "Top Cab Service Pune",
description: "Our Top Cab Service Pune is designed to deliver premium travel experience with clean vehicles, trained chauffeurs, and consistent on-time performance. Whether it is daily commuting, business travel, airport transfers, or intercity rides, we ensure comfort, safety, and reliability at every step. Rising Cab Service guarantees smooth booking, transparent pricing, and high-quality service standards for all passengers across Pune."
},
{
name: "Reliable Cab Service Pune",
description: "Rising Cab Service provides Reliable Cab Service Pune focused on consistent performance, verified drivers, and safe transportation for all travel needs. We ensure every ride is tracked, professionally managed, and executed with strict punctuality. Whether it is local travel, office commute, or long-distance trips, we maintain high service reliability and customer satisfaction with well-maintained AC vehicles and 24x7 support."
},
{
name: "Affordable Cab Service Pune",
description: "Book Affordable Cab Service Pune with Rising Cab Service for budget-friendly travel solutions without compromising comfort or safety. We offer competitive pricing, flexible ride options, and economical packages for daily commuting, airport transfers, and outstation travel. Our goal is to provide cost-effective transportation while maintaining high service quality, clean vehicles, and professional drivers."
},
{
name: "Trusted Cab Service Pune",
description: "Rising Cab Service is a Trusted Cab Service Pune provider known for secure rides, verified drivers, and dependable service across all routes. We ensure passenger safety, transparent billing, and consistent support for families, professionals, and tourists. Every journey is handled with care, making us one of the most trusted names in Pune cab services."
},
{
name: "Professional Cab Service Pune",
description: "Our Professional Cab Service Pune ensures disciplined, well-managed, and high-standard travel experience with trained chauffeurs, clean vehicles, and structured operations. We specialize in corporate travel, business meetings, airport transfers, and long-distance journeys, delivering punctuality, comfort, and professional behavior throughout the ride experience."
},
{
name: "Safe Cab Service Pune",
description: "Rising Cab Service ensures Safe Cab Service Pune with GPS-enabled vehicles, verified drivers, emergency support, and strict safety protocols. We prioritize passenger security for all rides including local, airport, and outstation travel. Our system ensures monitored journeys, reliable vehicles, and safe driving practices for complete peace of mind."
},
{
name: "AC Cab Service Pune",
description: "Book AC Cab Service Pune for comfortable and climate-controlled travel in all weather conditions. Our fleet includes well-maintained air-conditioned sedans, SUVs, and premium vehicles designed for smooth city rides and long-distance journeys. We ensure clean interiors, refreshing rides, and maximum passenger comfort."
},
{
name: "Luxury Cab Service Pune",
description: "Rising Cab Service offers Luxury Cab Service Pune with premium vehicles like Innova Crysta, SUV luxury models, and executive cars for high-end travel experiences. Ideal for business executives, VIP guests, weddings, and special occasions, we provide premium comfort, professional chauffeurs, and superior travel experience."
},
{
name: "Local Cab Service Pune",
description: "Our Local Cab Service Pune provides quick and efficient transportation within the city for office travel, shopping, meetings, and daily commuting. We ensure fast pickup, affordable pricing, and smooth city navigation with experienced drivers who know Pune routes well."
},
{
name: "Outstation Cab Service Pune",
description: "Rising Cab Service offers Outstation Cab Service Pune for safe and comfortable long-distance travel to destinations like Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, Kolhapur, and more. We provide reliable highway drivers, well-maintained vehicles, and flexible one-way and round-trip options."
},
{
name: "Corporate Cab Service Pune",
description: "Our Corporate Cab Service Pune is designed for companies, IT parks, and business professionals requiring employee transport, office commute, and executive travel solutions. We ensure punctual pickups, disciplined service, monthly billing options, and professional transportation management."
},
{
name: "Premium Cab Service Pune",
description: "Rising Cab Service delivers Premium Cab Service Pune with high-quality vehicles, superior comfort, and enhanced travel experience for business and leisure travelers. We focus on luxury interiors, smooth rides, and professional service standards."
},
{
name: "Cheapest Cab Service Pune",
description: "Book Cheapest Cab Service Pune for economical travel solutions without compromising safety and basic comfort. We provide budget-friendly fares, transparent pricing, and reliable service for daily commuters and short trips."
},
{
name: "Highly Rated Cab Pune",
description: "Rising Cab Service is a Highly Rated Cab Pune provider trusted by thousands of customers for consistent service quality, punctuality, safe driving, and comfortable rides across all travel categories including local and outstation journeys."
},
{
name: "Best Cab Service in Pune to Mumbai",
description: "Our Best Cab Service in Pune to Mumbai offers smooth highway travel with one-way and round-trip options, experienced drivers, and comfortable AC vehicles. Ideal for business trips, airport transfers, and weekend travel."
},
{
name: "Best Outstation Cab Service in Pune",
description: "Rising Cab Service provides Best Outstation Cab Service in Pune with safe intercity travel, professional chauffeurs, and well-maintained vehicles for long-distance journeys across Maharashtra and India."
},
{
name: "Best Taxi Service in Pune",
description: "Our Best Taxi Service in Pune ensures reliable, safe, and affordable transportation for local rides, airport transfers, and outstation travel with 24x7 availability and professional service."
},
{
name: "Best Cab Service Mumbai to Pune",
description: "Rising Cab Service offers Best Cab Service Mumbai to Pune with comfortable highway rides, experienced drivers, and flexible one-way and round-trip travel options for business and personal trips."
},
{
name: "Best Pune to Mumbai Cab Service",
description: "Book Best Pune to Mumbai Cab Service for fast, safe, and comfortable intercity travel with transparent pricing, clean vehicles, and professional chauffeurs ensuring smooth journey experience."
},
{
name: "Best Mumbai Pune Cab Service",
description: "Our Best Mumbai Pune Cab Service provides reliable intercity transportation with timely pickups, well-maintained cars, and experienced drivers for a stress-free travel experience."
},
{
name: "Round Trip Taxi Booking",
description: "Rising Cab Service offers Round Trip Taxi Booking for flexible travel plans with return journey convenience, waiting options, and cost-effective packages for intercity and outstation routes."
},
{
name: "Round Trip Cab Rental",
description: "Book Round Trip Cab Rental with Rising Cab Service for complete travel solutions including pickup, drop, waiting time, and return journey with comfortable and reliable vehicles."
},
{
name: "Intercity Round Trip Cab",
description: "Our Intercity Round Trip Cab service ensures smooth and safe travel between cities with professional drivers, flexible schedules, and comfortable AC vehicles."
},
{
name: "Outstation Cab Round Trip",
description: "Rising Cab Service provides Outstation Cab Round Trip options for long-distance travel with return flexibility, ideal for family trips, business travel, and tourism."
},
{
name: "Round Trip Airport Taxi",
description: "Book Round Trip Airport Taxi for seamless airport transfers with pickup and drop service, ensuring timely arrivals and comfortable rides."
},
{
name: "Round Trip Innova Cab",
description: "Rising Cab Service offers Round Trip Innova Cab for group and family travel with spacious seating, premium comfort, and reliable long-distance transportation."
},
{
name: "Long Distance Taxi Service",
description: "Our Long Distance Taxi Service ensures safe, comfortable, and reliable intercity travel across Maharashtra and India with experienced drivers and well-maintained vehicles."
},
{
name: "Round Trip Travel Cab",
description: "Rising Cab Service provides Round Trip Travel Cab for flexible travel planning with return journey convenience, smooth rides, and affordable packages."
},
{
name: "Best Cab Service in Pune",
description: "Rising Cab Service delivers the Best Cab Service in Pune with reliable drivers, clean vehicles, and 24x7 availability for local, airport, and outstation travel."
},
{
name: "Best Taxi Service in Pune",
description: "Our Best Taxi Service in Pune ensures safe, affordable, and comfortable transportation for all travel needs including city rides, airport transfers, and long-distance trips."
},
{
name: "Top Cab Service Pune",
description: "Rising Cab Service offers Top Cab Service Pune with premium quality vehicles, trained chauffeurs, and consistent on-time service for all types of travel."
},
{
name: "Reliable Cab Service in Pune",
description: "Our Reliable Cab Service in Pune ensures consistent performance, verified drivers, and safe travel experience for local and outstation journeys."
},
{
name: "24x7 Cab Service Pune",
description: "Rising Cab Service provides 24x7 Cab Service Pune with round-the-clock availability for emergency rides, airport transfers, and late-night travel needs."
},
{
name: "Affordable Cab Service Pune",
description: "Book Affordable Cab Service Pune for budget-friendly travel options with safe rides, transparent pricing, and comfortable vehicles."
},
{
name: "Online Cab Booking Pune",
description: "Rising Cab Service offers Online Cab Booking Pune with instant confirmation, easy booking process, and multiple vehicle options for all travel needs."
}
],

tableData: [
["Best Cab Service in Pune","Top Cab Service Pune"],
["Reliable Cab Service Pune","Affordable Cab Service Pune"],
["Trusted Cab Service Pune","Professional Cab Service Pune"],
["Safe Cab Service Pune","AC Cab Service Pune"],
["Luxury Cab Service Pune","Local Cab Service Pune"],
["Outstation Cab Service Pune","Corporate Cab Service Pune"],
["Premium Cab Service Pune","Cheapest Cab Service Pune"],
["Highly Rated Cab Pune","Best Cab Service in Pune to Mumbai"],
["Best Outstation Cab Service in Pune","Best Taxi Service in Pune"],
["Best Cab Service Mumbai to Pune","Best Pune to Mumbai Cab Service"],
["Best Mumbai Pune Cab Service","Round Trip Taxi Booking"],
["Round Trip Cab Rental","Intercity Round Trip Cab"],
["Outstation Cab Round Trip","Round Trip Airport Taxi"],
["Round Trip Innova Cab","Long Distance Taxi Service"],
["Round Trip Travel Cab","24x7 Cab Service Pune"],
["Online Cab Booking Pune","Reliable Cab Service in Pune"]
],



whychoose: [
    {
        WhyChooseheading: "One of the Best Cab Services in Pune",
        WhyChoosedescription: "Rising Cab Service is known for providing reliable transportation solutions for local travel, airport transfers, outstation trips, corporate travel, and sightseeing tours."
    },
    {
        WhyChooseheading: "Professional Drivers and Quality Service",
        WhyChoosedescription: "Our trained drivers focus on punctuality, passenger safety, route knowledge, and customer satisfaction for every journey."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Travel",
        WhyChoosedescription: "From daily city rides to long-distance travel across Maharashtra and India, we offer transportation services for every travel requirement."
    },
    {
        WhyChooseheading: "Large Fleet of Comfortable Vehicles",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        WhyChooseheading: "Airport, Railway, and Corporate Transfers",
        WhyChoosedescription: "Our services are widely used for Pune Airport transfers, railway station pickups, employee transportation, and executive travel."
    },
    {
        WhyChooseheading: "Pickup Across Pune and PCMC",
        WhyChoosedescription: "We provide pickup facilities from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding locations."
    },
    {
        WhyChooseheading: "Comfortable Travel for Every Occasion",
        WhyChoosedescription: "Whether it is a family vacation, business meeting, pilgrimage tour, wedding function, or weekend getaway, we provide suitable travel options."
    },
    {
        WhyChooseheading: "Trusted by Thousands of Travelers",
        WhyChoosedescription: "Rising Cab Service continues to be a preferred choice for families, tourists, students, senior citizens, and corporate customers across Pune."
    }
]
};

const faqData = [
    {
        question: "Why is Rising Cab Service considered one of the best cab services in Pune?",
        answer: "Rising Cab Service offers reliable vehicles, experienced drivers, punctual service, and flexible travel solutions for local and outstation journeys."
    },
    {
        question: "Do you provide airport cab services in Pune?",
        answer: "Yes, airport pickup and drop services are available for Pune Airport and nearby destinations."
    },
    {
        question: "Can I hire a cab for outstation travel?",
        answer: "Yes, outstation cab services are available for destinations across Maharashtra and various cities throughout India."
    },
    {
        question: "Which vehicles are available for booking?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and luxury vehicles."
    },
    {
        question: "Are cabs available for corporate travel requirements?",
        answer: "Yes, our services are regularly used for business meetings, employee transportation, conferences, and executive travel."
    },
    {
        question: "Can families book larger vehicles for tours and events?",
        answer: "Yes, Tempo Travellers and larger group vehicles are available for family trips, functions, and sightseeing tours."
    },
    {
        question: "Do you provide railway station pickup and drop services?",
        answer: "Yes, transportation services are available to and from Pune Railway Station and nearby railway terminals."
    },
    {
        question: "Can I reserve a cab in advance?",
        answer: "Yes, advance booking facilities are available for planned travel, holidays, tours, and special occasions."
    },
    {
        question: "Is pickup available across Pune and PCMC?",
        answer: "Yes, we provide pickup services from all major residential, commercial, and business areas in Pune and Pimpri Chinchwad."
    },
    {
        question: "How can I book the best cab service in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Abhijeet More",
        feedback:
            "After trying several taxi providers, Rising Cab Service stood out because of its punctuality and professional approach. The entire journey was comfortable and well-managed.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Minal Joshi",
        feedback:
            "Excellent vehicle quality, courteous drivers, and dependable service make Rising Cab Service our preferred travel partner whenever we need transportation in Pune.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Best Cab Service in Pune",
"image": "https://www.risingcabservice.com/assets/images/best-cab-service-pune.jpg",
"description": "Book Best Cab Service in Pune with Rising Cab Service for safe, reliable, and affordable local and outstation travel. Enjoy 24x7 taxi service with AC sedans, SUVs, and Innova cars for city, airport, and corporate rides.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/best-cab-service-in-pune"
}
};





    return (
        <div>

<Helmet>
  <title>Best Cab Service in Pune | Trusted 24x7 Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Best Cab Service in Pune with Rising Cab Service for safe, reliable, and affordable travel. Get 24x7 local, airport, and outstation cab service with AC cars and professional drivers."
/>

<meta
 name="keywords"
 content="Best cab service in pune, top cab service pune, reliable cab service pune, affordable cab service pune, trusted cab service pune, professional cab service pune, safe cab service pune, ac cab service pune, luxury cab service pune, local cab service pune, outstation cab service pune, corporate cab service pune, premium cab service pune, cheapest cab service pune, highly rated cab service pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestcabserviceinpune;